var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout " }, [
    _c(
      "div",
      { staticClass: "jp-common-layout-left", staticStyle: { width: "370px" } },
      [
        _c(
          "div",
          { staticClass: "jp-common-title flexTreeTitle" },
          [
            _c("el-input", {
              staticStyle: { width: "245px" },
              attrs: {
                placeholder: "请输入关键字进行过滤",
                size: "small",
                clearable: "",
              },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText",
              },
            }),
            _c(
              "div",
              [
                _c("el-button", {
                  attrs: {
                    size: "small",
                    type: "primary",
                    circle: "",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.searchTree("search")
                    },
                  },
                }),
                _c("el-button", {
                  attrs: {
                    size: "small",
                    type: "primary",
                    circle: "",
                    icon: "fa fa-random",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.searchTree("expandAll")
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
          _c(
            "div",
            {
              staticClass: "el-scrollbar__wrap",
              style: { height: _vm.treeHeight - 40 + "px", marginTop: "20px" },
            },
            [
              _c(
                "div",
                { staticClass: "el-scrollbar__view" },
                [
                  _c(
                    "vxe-table",
                    {
                      ref: "xTree",
                      attrs: {
                        "show-overflow": "",
                        border: "none",
                        height: _vm.treeHeight - 40 + "px",
                        loading: _vm.loadingTree,
                        "show-header": false,
                        "tree-config": {
                          transform: true,
                          rowField: "id",
                          parentField: "parentIdNew",
                          expandAll: _vm.treeExpandAll,
                          reserve: true,
                        },
                        "radio-config": { labelField: "nameCn" },
                        "row-config": {
                          keyField: "id",
                          isCurrent: true,
                          isHover: true,
                        },
                        data: _vm.showTreeList,
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: { field: "nameCn", "tree-node": "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "treeSpan",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handRow(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.name))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]
    ),
    _c("div", { staticClass: "jp-common-layout-center jp-flex-main" }, [
      _c(
        "div",
        { staticClass: "page" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "query-form",
              attrs: { size: "small", inline: true, model: _vm.searchForm },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.refreshList()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "nameCnEe" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "中/英名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.nameCnEe,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "nameCnEe", $$v)
                      },
                      expression: "searchForm.nameCnEe",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "code" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "物品编码",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "code", $$v)
                      },
                      expression: "searchForm.code",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "cascaderValue" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.categoryTree,
                      props: { multiple: false, checkStrictly: true },
                      clearable: "",
                    },
                    on: { change: _vm.handCascader },
                    model: {
                      value: _vm.searchForm.cascaderValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cascaderValue", $$v)
                      },
                      expression: "searchForm.cascaderValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "itemPeroperty" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { clearable: "", placeholder: "属性" },
                      model: {
                        value: _vm.searchForm.itemPeroperty,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "itemPeroperty", $$v)
                        },
                        expression: "searchForm.itemPeroperty",
                      },
                    },
                    _vm._l(
                      _vm.$dictUtils.getDictList("cec_item_property"),
                      function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.refreshList()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh-right" },
                      on: {
                        click: function ($event) {
                          return _vm.resetSearch()
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bg-white top" },
            [
              _c("vxe-toolbar", {
                scopedSlots: _vm._u([
                  {
                    key: "buttons",
                    fn: function () {
                      return [
                        _vm.hasPermission("cecitem:cecItem:getCec")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "success",
                                  icon: "el-icon-refresh-right",
                                  loading: _vm.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getCecItem()
                                  },
                                },
                              },
                              [_vm._v("获取CEC材料数据")]
                            )
                          : _vm._e(),
                        _vm.hasPermission("cecitem:cecItem:getCec")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "success",
                                  icon: "el-icon-refresh-right",
                                  loading: _vm.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getCecitemagilefield()
                                  },
                                },
                              },
                              [_vm._v("获取CEC材料扩展数据")]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "div",
                { staticStyle: { height: "calc(100% - 80px)" } },
                [
                  _c(
                    "vxe-table",
                    {
                      ref: "cecItemTable",
                      attrs: {
                        border: "full",
                        "auto-resize": "",
                        resizable: "",
                        height: "auto",
                        loading: _vm.loading,
                        size: "small",
                        "show-header-overflow": "",
                        "show-overflow": "",
                        "highlight-hover-row": "",
                        "menu-config": {},
                        "print-config": {},
                        "import-config": {
                          importMethod: _vm.importMethod,
                          types: ["csv", "xls", "xlsx"],
                          remote: true,
                        },
                        "export-config": {
                          remote: true,
                          filename:
                            "材料表数据" +
                            _vm.moment(new Date()).format("YYYY-MM-DD"),
                          sheetName: "材料表数据",
                          exportMethod: _vm.exportMethod,
                          types: ["xlsx"],
                          modes: ["current", "selected", "all"],
                        },
                        "expand-config": {
                          accordion: true,
                          lazy: true,
                          loadMethod: _vm.loadContentMethod,
                        },
                        "sort-config": { remote: true },
                        data: _vm.dataList,
                        "checkbox-config": {},
                      },
                      on: { "sort-change": _vm.sortChangeHandle },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          type: "seq",
                          align: "center",
                          width: "50",
                          title: "序号",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: { type: "expand", width: "50", title: "展开" },
                        scopedSlots: _vm._u([
                          {
                            key: "content",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { padding: "10px" } },
                                  [
                                    _c(
                                      "vxe-table",
                                      {
                                        ref: "cecItemTable2",
                                        attrs: {
                                          border: "full",
                                          "auto-resize": "",
                                          resizable: "",
                                          loading: _vm.loading,
                                          size: "small",
                                          "show-header-overflow": "",
                                          "show-overflow": "",
                                          "highlight-hover-row": "",
                                          data: row.childData,
                                        },
                                      },
                                      [
                                        _c("vxe-column", {
                                          attrs: {
                                            type: "seq",
                                            align: "center",
                                            width: "50",
                                            title: "序号",
                                          },
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "code",
                                            align: "center",
                                            width: "150",
                                            sortable: "",
                                            title: "编码",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm.hasPermission(
                                                      "cecitem:cecItem:view"
                                                    )
                                                      ? _c(
                                                          "el-link",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              underline: false,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.view(
                                                                  scope.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.code
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.code
                                                            )
                                                          ),
                                                        ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "name",
                                            align: "center",
                                            width: "200",
                                            sortable: "",
                                            title: "英文名称",
                                          },
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "nameCn",
                                            align: "center",
                                            width: "200",
                                            sortable: "",
                                            title: "中文名称",
                                          },
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "category.name",
                                            align: "center",
                                            width: "200",
                                            sortable: "",
                                            title: "分类",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            scope.row.category
                                                              .parentIdsName,
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "textOverflow",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .category.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "itemPeroperty",
                                            align: "center",
                                            width: "80",
                                            sortable: "",
                                            title: "属性",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.setItemPeropertyText(
                                                            scope.row
                                                              .itemPeroperty
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "price",
                                            align: "center",
                                            width: "80",
                                            sortable: "",
                                            title: "单价",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flexBetween",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("$"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$mathUtil.mathToFixed(
                                                                scope.row.price
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "unit",
                                            align: "center",
                                            width: "80",
                                            sortable: "",
                                            title: "单位",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.units.unitEn
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("vxe-column", {
                                          attrs: {
                                            field: "description",
                                            align: "center",
                                            title: "描述",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "code",
                          align: "center",
                          width: "80",
                          sortable: "",
                          title: "编码",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.hasPermission("cecitem:cecItem:view")
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          type: "primary",
                                          underline: false,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.view(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.code))]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(scope.row.code)),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "name",
                          align: "center",
                          "min-width": "200",
                          sortable: "",
                          title: "英文名称",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.parentId == "0" &&
                                        scope.row.mainItemId
                                        ? scope.row.mainItemName
                                        : scope.row.name
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "nameCn",
                          align: "center",
                          "min-width": "200",
                          sortable: "",
                          title: "中文名称",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.parentId == "0" &&
                                        scope.row.mainItemId
                                        ? scope.row.mainItemNameCn
                                        : scope.row.nameCn
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "category.name",
                          align: "center",
                          width: "200",
                          sortable: "",
                          title: "分类",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.category.parentIdsName,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(_vm._s(scope.row.category.name)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "itemPeroperty",
                          align: "center",
                          width: "80",
                          sortable: "",
                          title: "属性",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.setItemPeropertyText(
                                        scope.row.itemPeroperty
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "price",
                          align: "center",
                          width: "80",
                          sortable: "",
                          title: "单价",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "flexBetween" }, [
                                  _c("span", [_vm._v("$")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$mathUtil.mathToFixed(
                                          scope.row.price
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "unit",
                          align: "center",
                          width: "80",
                          sortable: "",
                          title: "单位",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " + _vm._s(scope.row.units.unitEn) + " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "description",
                          align: "center",
                          "min-width": "100",
                          title: "描述",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("vxe-pager", {
                    attrs: {
                      background: "",
                      size: "small",
                      "current-page": _vm.tablePage.currentPage,
                      "page-size": _vm.tablePage.pageSize,
                      total: _vm.tablePage.total,
                      "page-sizes": [
                        10,
                        20,
                        100,
                        1000,
                        { label: "全量数据", value: 1000000 },
                      ],
                      layouts: [
                        "PrevPage",
                        "JumpNumber",
                        "NextPage",
                        "FullJump",
                        "Sizes",
                        "Total",
                      ],
                    },
                    on: { "page-change": _vm.currentChangeHandle },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("CecItemForm", {
            ref: "cecItemForm",
            on: { refreshDataList: _vm.refreshList },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }